import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { BillingForm } from "./BillingForm";

export function OrderSummary({
  totalPrice,
  totalItems,
}: {
  totalPrice: number;
  totalItems: number;
}) {
  return (
    <div>
      {/* Header */}
      <div className="py-3">
        <div className="space-y-10">
          <h1 className="text-lg font-extrabold -tracking-wide text-neutral-800">
            Order Summary
          </h1>
          <div className="space-y-3">
            <div className="space-y-2">
              <p>
                {totalItems} item{totalItems > 1 ? "s" : ""}
              </p>
              <Separator className="" />
              <div className="flex flex-row justify-between px-1 py-2">
                <p className="text-md leading-none font-extrabold text-neutral-900">
                  Total
                </p>
                <p className="text-brand-500 text-lg leading-none font-extrabold -tracking-wide">
                  $
                  {Number(totalPrice).toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                  })}
                  /mo
                </p>
              </div>
            </div>

            <div className="space-y-6">
              <Button className="bg-purple hover:bg-purple/90 flex h-[48px] w-full flex-row items-center justify-center gap-1.5">
                <h1>Pay with </h1>
                <img
                  src="/logo/stripe-logo.svg"
                  className="h-5 w-10"
                  alt="Stripe Logo"
                />
              </Button>

              <div className="mx-auto flex w-full flex-row items-center justify-center gap-2">
                <Separator className="flex-1" />
                <p className="text-sm font-semibold text-neutral-900">or</p>
                <Separator className="flex-1" />
              </div>
            </div>
            <BillingForm />
          </div>
        </div>
      </div>
    </div>
  );
}
